module.exports = __webpack_public_path__ + "static/media/logo.21514978.jpg";